export enum ActivityPlayerEvent {
  LESSON_COMPLETE = 'lessonComplete',
  ACTIVITY_COMPLETE = 'activityComplete',
  SLIDE_CHANGED = 'slideChanged',
  FINISH_LESSON = 'finishLesson',
  REQUEST_LESSON_INFO = 'requestLessonInfo',
  SEND_LESSON_INFO = 'sendLessonInfo',
  REQUEST_STUDENT_INFO = 'requestUserInfo',
  SEND_STUDENT_INFO = 'sendUserInfo',
  REFERRAL_BUTTON_CLICKED = 'referralButtonClicked',
  NAVIGATE_HOME = 'navigateHome',
  OPEN_CHAT_BOT_LESSON = 'openChatBotLesson',
  SEND_CHAT_BOT_LESSON_INFO = 'sendChatBotLessonInfo'
}



// WEBPACK FOOTER //
// ./ts/app/shared/activity-player/activity-player-event.enum.ts